import { useState } from 'react';
import { IconBug, IconBulb, IconDeviceDesktop, IconLayoutGrid, IconRoute, IconSend } from '@tabler/icons-react';
import { Button, Chip, Drawer, Segmented, useToast } from '@hana/ui';
import s from './shell.module.css';
import { useT } from '@hana/i18n';

/** Góp ý (MINT FEEDBACK KIT v1) — bản vỏ: form + ngữ cảnh tự ghi; chưa có nơi nhận nên chỉ báo đã ghi trên máy. */
export function Feedback({ open, onOpenChange, zone, screen }: { open: boolean; onOpenChange: (o: boolean) => void; zone: string; screen: string }) {
  const t = useT();
  const toast = useToast();
  const [kind, setKind] = useState<'bug' | 'idea'>('bug');
  const [desc, setDesc] = useState('');
  const dev = typeof navigator === 'undefined' ? '' : `${innerWidth}×${innerHeight}`;
  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
      title={t('shell.feedback')}
      footer={
        <>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>
          <Button
            variant="primary"
            icon={<IconSend size={16} />}
            disabled={!desc.trim()}
            onClick={() => {
              onOpenChange(false);
              setDesc('');
              toast({ msg: t('shell.fbDone') });
            }}
          >
            {t('shell.fbSend')}
          </Button>
        </>
      }
    >
      <Segmented
        kind="toggle"
        label={t('shell.fbKind')}
        value={kind}
        onChange={setKind}
        items={[
          { key: 'bug', label: <><IconBug size={15} /> {t('shell.fbBug')}</> },
          { key: 'idea', label: <><IconBulb size={15} /> {t('shell.fbIdea')}</> },
        ]}
      />
      <label className={s.fbLbl} htmlFor="fbDesc">
        {t('shell.fbDesc')}
      </label>
      <textarea id="fbDesc" className={s.ta} value={desc} onChange={(e) => setDesc(e.target.value)} placeholder={t('shell.fbPh')} />
      <div className={s.fbLbl}>{t('shell.fbCtx')}</div>
      <div className={s.ctx}>
        <Chip label={t('shell.zone')} icon={<IconLayoutGrid size={13} />}>
          {zone}
        </Chip>
        <Chip label={t('shell.screen')} icon={<IconRoute size={13} />}>
          {screen}
        </Chip>
        {dev && (
          <Chip label={t('shell.display')} icon={<IconDeviceDesktop size={13} />}>
            {dev}
          </Chip>
        )}
      </div>
    </Drawer>
  );
}
